import { connect } from 'react-redux';
import TargetAmountView from './TargetAmountView';
import {
  currentClientId,
  iterator,
  isPopulatedSelector,
  data2 as data2Selector,
} from '../../AdvWorkflow/AdvWorkflowSelector';
import { updateData, fetchData } from '../../AdvWorkflow/AdvWorkflowActions';
import { goalSelector, defaultTargetAmountSelector } from '../EmergencyFundWorkflowSelector';
import { BACKEND_KEY as PersonalInfoKey } from '../../PersonalInfoWorkflow/PersonalInfoWorkflowConstants';

const mapStateToProps = (state, ownProps) => ({
  clientId: currentClientId(state, ownProps),
  targetAmount: goalSelector(state, ownProps).FundSize,
  defaultTargetAmount: defaultTargetAmountSelector(state, ownProps),
  iterator: iterator(state, ownProps),
  isPopulated: isPopulatedSelector(state, ownProps),
  targetYear: goalSelector(state, ownProps).FundedDate,
  hasPartner: data2Selector(state, ownProps)(`${PersonalInfoKey}.HasPartner`),
});

const mapDispatchToProps = dispatch => ({
  store: workflowId => (data, clientId) => dispatch(updateData(data, workflowId, clientId)),
  fetchData: (workflowId, clientId) => dispatch(fetchData(workflowId, clientId)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TargetAmountView);
